// removed by extract-text-webpack-plugin
module.exports = {"root":"ChaliceRecipie--root--3J","recipie":"ChaliceRecipie--recipie--3h","slot":"ChaliceRecipie--slot--3D","and":"ChaliceRecipie--and--hD","icon":"ChaliceRecipie--icon--jJ","rune":"ChaliceRecipie--rune--35"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChaliceRecipie/styles.styl
// module id = 848
// module chunks = 0